import Error from "@/components/Error";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/consortium" });
  },
  errorComponent: () => <Error status={403} />,
});
